"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const luxon_1 = require("luxon");
const react_redux_1 = require("react-redux");
const immutable_1 = require("immutable");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const styles_1 = require("@mui/material/styles");
const ItemizedTransactions_styles_1 = __importDefault(require("containers/NewReports/components/ItemizedTransactions/ItemizedTransactions.styles"));
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
const tags_1 = require("companion-app-components/flux/tags");
const auth_1 = require("companion-app-components/flux/auth");
const transactions_1 = require("companion-app-components/flux/transactions");
const retrievers_1 = require("data/accounts/retrievers");
const types_1 = require("data/transactions/types");
const reportsSelectors = __importStar(require("data/reports/selectors"));
const utils_1 = require("data/reports/utils");
const state_1 = require("containers/NewReports/state");
const ChartSettings_1 = __importDefault(require("containers/NewReports/components/ChartSettings"));
const useQData_1 = __importDefault(require("components/QData/useQData"));
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const BulkEditPanel_1 = __importDefault(require("components/BulkEditPanel"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const happy_star_svg_1 = __importDefault(require("assets/happy-star.svg"));
const utils_2 = require("./utils");
const ItemizedTable_1 = __importDefault(require("./ItemizedTable"));
const types_2 = require("./types");
const ItemizedTransactions = () => {
    var _a, _b, _c, _d, _e, _f;
    const theme = (0, styles_1.useTheme)();
    const { palette } = theme;
    const { classes, cx } = (0, ItemizedTransactions_styles_1.default)();
    const { qDataSaveTransactions, qDataDeleteTransactions } = (0, useQData_1.default)();
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const { datasetPreferences } = (0, useQPreferences_1.default)();
    const { state } = react_1.default.useContext(state_1.ReportsStateContext);
    const { dateRange, filterObject, timeStep } = state;
    const [breakdownBy, setBreakdownBy] = react_1.default.useState('category');
    const [view, setView] = react_1.default.useState('top');
    const [sortBy, setSortBy] = react_1.default.useState('date');
    const [sortDirection, setSortDirection] = react_1.default.useState('desc');
    const [hasUserSorted, setHasUserSorted] = react_1.default.useState(false);
    const [expandedKeys, setExpandedKeys] = react_1.default.useState({});
    const [selectedTxns, setSelectedTxns] = react_1.default.useState((0, immutable_1.Set)());
    const [showBulkEdit, setShowBulkEdit] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        setSelectedTxns((prev) => {
            if (prev.size === 0)
                return prev;
            const interval = dateRange === null || dateRange === void 0 ? void 0 : dateRange.value;
            const filtered = prev.filter((txn) => {
                if (!interval)
                    return false;
                const postedOn = (0, utils_2.getTxnField)(txn, 'postedOn');
                if (!postedOn)
                    return false;
                const selecteTxnDate = luxon_1.DateTime.fromISO(postedOn);
                return selecteTxnDate.isValid && interval.contains(selecteTxnDate);
            });
            if (filtered.size === 0)
                setShowBulkEdit(false);
            return filtered;
        });
    }, [dateRange, filterObject]);
    const toggleExpanded = react_1.default.useCallback((key, defaultExpanded = true) => {
        setExpandedKeys((prev) => (0, utils_2.getNextExpandedKeys)(prev, key, defaultExpanded));
    }, []);
    const tagsById = (0, react_redux_1.useSelector)((store) => tags_1.tagsSelectors.getTags(store));
    const accountsById = (0, react_redux_1.useSelector)((store) => accounts_1.accountsSelectors.getAccountsById(store));
    const categoriesById = (0, react_redux_1.useSelector)((store) => categories_1.categoriesSelectors.getCategoriesById(store));
    const dataset = (0, react_redux_1.useSelector)(auth_1.authSelectors.getCurrentDataset);
    const getAccountName = react_1.default.useCallback((id) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const accountMap = accountsById;
        const normalizedId = id == null ? '' : String(id);
        const numericId = typeof id === 'number' || (typeof id === 'string' && id.trim() !== '' && Number.isFinite(Number(id)))
            ? String(Number(id))
            : '';
        return (_g = (_f = (_c = (_b = (_a = accountMap === null || accountMap === void 0 ? void 0 : accountMap.get) === null || _a === void 0 ? void 0 : _a.call(accountMap, normalizedId)) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : (_e = (_d = accountMap === null || accountMap === void 0 ? void 0 : accountMap.get) === null || _d === void 0 ? void 0 : _d.call(accountMap, numericId)) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : (0, retrievers_1.getAccountString)(id)) !== null && _g !== void 0 ? _g : '';
    }, [accountsById]);
    const getTxnAmountForRow = react_1.default.useCallback((txn, row) => {
        var _a;
        const splitItems = (_a = txn.split) === null || _a === void 0 ? void 0 : _a.items;
        let items = [];
        if (Array.isArray(splitItems)) {
            items = splitItems;
        }
        else if (splitItems && typeof splitItems.toArray === 'function') {
            items = splitItems.toArray();
        }
        if (items.length === 0) {
            return (0, utils_2.toNumber)((0, utils_2.getTxnField)(txn, 'amount'));
        }
        let matched = false;
        let sum = 0;
        items.forEach((split) => {
            const splitRecord = split;
            const splitAmount = (0, utils_2.toNumber)(typeof splitRecord.get === 'function' ? splitRecord.get('amount') : split === null || split === void 0 ? void 0 : split.amount);
            if (!Number.isFinite(splitAmount))
                return;
            const splitCoa = (typeof splitRecord.get === 'function' ? splitRecord.get('coa') : split === null || split === void 0 ? void 0 : split.coa);
            const splitForGrouping = typeof splitRecord.get === 'function'
                ? {
                    amount: splitAmount,
                    coa: splitCoa,
                    tags: splitRecord.get('tags'),
                }
                : split;
            if (row.categoryId && ((splitCoa === null || splitCoa === void 0 ? void 0 : splitCoa.id) === row.categoryId || String(splitCoa === null || splitCoa === void 0 ? void 0 : splitCoa.id) === String(row.categoryId))) {
                matched = true;
                sum += splitAmount;
                return;
            }
            const { groupKeys } = (0, utils_1.getGroupingKeys)(txn, splitForGrouping, breakdownBy, categoriesById, tagsById);
            if (row.groupKey != null && (groupKeys === null || groupKeys === void 0 ? void 0 : groupKeys.includes(row.groupKey))) {
                matched = true;
                sum += splitAmount;
            }
        });
        return matched ? sum : (0, utils_2.toNumber)((0, utils_2.getTxnField)(txn, 'amount'));
    }, [breakdownBy, categoriesById, tagsById]);
    const incomeReport = (0, react_redux_1.useSelector)((store) => reportsSelectors.getIncomeSpendingReportForDisplay(store, {
        reportName: 'income',
        dateRange: dateRange.value,
        timeStep,
        isOverTime: false,
        chartType: 'pie',
        groupBy: breakdownBy,
        filterObject,
    }));
    const expenseReport = (0, react_redux_1.useSelector)((store) => reportsSelectors.getIncomeSpendingReportForDisplay(store, {
        reportName: 'spending',
        dateRange: dateRange.value,
        timeStep,
        isOverTime: false,
        chartType: 'pie',
        groupBy: breakdownBy,
        filterObject,
    }));
    const incomeGroups = react_1.default.useMemo(() => {
        const raw = incomeReport === null || incomeReport === void 0 ? void 0 : incomeReport.get('rawReport');
        const groups = raw === null || raw === void 0 ? void 0 : raw.get('groups');
        return (0, utils_2.mapGroupRecordToNodes)(groups);
    }, [incomeReport]);
    const expenseGroups = react_1.default.useMemo(() => {
        const raw = expenseReport === null || expenseReport === void 0 ? void 0 : expenseReport.get('rawReport');
        const groups = raw === null || raw === void 0 ? void 0 : raw.get('groups');
        return (0, utils_2.mapGroupRecordToNodes)(groups);
    }, [expenseReport]);
    const maxDepth = react_1.default.useMemo(() => {
        if (view === 'category')
            return 1;
        return 6;
    }, [view]);
    const incomeRows = react_1.default.useMemo(() => (0, utils_2.flattenNodesForView)((0, utils_2.injectOtherBucket)(incomeGroups), maxDepth), [incomeGroups, maxDepth]);
    const expenseRows = react_1.default.useMemo(() => (0, utils_2.flattenNodesForView)((0, utils_2.injectOtherBucket)(expenseGroups), maxDepth), [expenseGroups, maxDepth]);
    const isTransactionsView = view === 'transactions';
    const handleHeaderSort = react_1.default.useCallback((nextSortBy) => {
        if (!isTransactionsView)
            return;
        setHasUserSorted(true);
        if (nextSortBy === sortBy) {
            const nextDirection = sortDirection === 'asc' ? 'desc' : 'asc';
            setSortDirection(nextDirection);
            return;
        }
        const nextDirection = nextSortBy === 'date' || nextSortBy === 'amount' ? 'desc' : 'asc';
        setSortBy(nextSortBy);
        setSortDirection(nextDirection);
    }, [isTransactionsView, sortBy, sortDirection]);
    const visibleTxns = react_1.default.useMemo(() => {
        const collect = (rows, sectionKey) => {
            let visibleTransactions = (0, immutable_1.Set)();
            let depthOpen = [];
            let lastRendered = null;
            rows.forEach((row) => {
                var _a, _b, _c, _d;
                depthOpen = depthOpen.slice(0, row.depth);
                const parentExpanded = row.depth === 0 ? true : (_a = depthOpen[row.depth - 1]) !== null && _a !== void 0 ? _a : true;
                if (!parentExpanded) {
                    depthOpen[row.depth] = false;
                    return;
                }
                const key = `${sectionKey}-${row.categoryId || row.groupKey}-${row.depth}`;
                const hasChildren = Array.isArray(row.subgroups) && row.subgroups.length > 0;
                const hasVisibleChildren = hasChildren && row.depth < maxDepth;
                const hasTxnRows = Boolean(row.txns && row.txns.size > 0);
                const canExpandLeafTxns = !hasVisibleChildren && hasTxnRows;
                let isExpanded = (_b = expandedKeys[key]) !== null && _b !== void 0 ? _b : view !== 'top';
                if (canExpandLeafTxns) {
                    isExpanded = (_c = expandedKeys[key]) !== null && _c !== void 0 ? _c : isTransactionsView;
                }
                if (view === 'category' && row.leafParent) {
                    isExpanded = (_d = expandedKeys[key]) !== null && _d !== void 0 ? _d : false;
                }
                depthOpen[row.depth] = isExpanded;
                const isDuplicateLabel = lastRendered && row.depth === lastRendered.depth + 1 && row.groupKey === lastRendered.groupKey;
                if (isDuplicateLabel && !hasVisibleChildren) {
                    if (parentExpanded && row.txns && row.txns.size > 0) {
                        visibleTransactions = visibleTransactions.union(row.txns);
                    }
                    lastRendered = { groupKey: row.groupKey, depth: row.depth };
                    return;
                }
                if (!hasVisibleChildren && row.txns && row.txns.size > 0) {
                    if (isExpanded) {
                        visibleTransactions = visibleTransactions.union(row.txns);
                    }
                }
                lastRendered = { groupKey: row.groupKey, depth: row.depth };
            });
            return visibleTransactions;
        };
        return collect(incomeRows, 'income').union(collect(expenseRows, 'expenses'));
    }, [expenseRows, expandedKeys, incomeRows, isTransactionsView, maxDepth, view]);
    const toggleSelectAllVisible = react_1.default.useCallback(() => {
        if (visibleTxns.size === 0)
            return;
        setSelectedTxns((prev) => {
            const allSelected = visibleTxns.size > 0 && visibleTxns.every((txn) => prev.has(txn));
            return allSelected ? prev.subtract(visibleTxns) : prev.union(visibleTxns);
        });
    }, [visibleTxns]);
    const toggleTxnSelected = react_1.default.useCallback((txn) => {
        setSelectedTxns((prev) => (prev.has(txn) ? prev.remove(txn) : prev.add(txn)));
    }, []);
    const clearSelection = react_1.default.useCallback(() => setSelectedTxns((0, immutable_1.Set)()), []);
    const selectedTotal = react_1.default.useMemo(() => selectedTxns.toArray().reduce((total, txn) => total + (0, utils_2.toNumber)((0, utils_2.getTxnField)(txn, 'amount')), 0), [selectedTxns]);
    const setTxnReviewed = react_1.default.useCallback((txn) => {
        if (txn && !(0, utils_2.getTxnField)(txn, 'isReviewed')) {
            return txn.set('isReviewed', true);
        }
        return txn;
    }, []);
    const bulkEditSave = react_1.default.useCallback((fields) => {
        var _a;
        if (!fields || Object.keys(fields).length === 0)
            return;
        const { coa, tags: fieldTags } = fields, otherFields = __rest(fields, ["coa", "tags"]);
        const newTxns = (_a = selectedTxns.map((item) => {
            let newTxn = setTxnReviewed(item);
            if (!transactions_1.transactionsUtils.isSplitTxn(item)) {
                if (coa) {
                    newTxn = newTxn.set('coa', coa);
                }
                if (fieldTags) {
                    newTxn = newTxn.set('tags', newTxn.tags ? newTxn.tags.merge(fieldTags) : fieldTags);
                }
                if (item.source === types_1.TxnPendingStates.QCS_REFRESH_BANK_PENDING) {
                    newTxn = newTxn.set('source', types_1.TxnPendingStates.USER_OWNED_BANK_PENDING);
                }
            }
            return newTxn.merge(otherFields);
        })) !== null && _a !== void 0 ? _a : (0, immutable_1.Set)();
        const pluralSuffix = newTxns.size > 1 ? 's' : '';
        dialogAlert(`Save Changes To ${newTxns.size} Transaction${pluralSuffix}`, 'This will apply the specified changes to all eligible transactions you selected and cannot be undone. Do you want to proceed?', (button) => {
            if (button.btnPressed === 'Yes') {
                qDataSaveTransactions(newTxns);
                clearSelection();
            }
        }, ['Cancel', 'Yes'], 'warning', false);
    }, [selectedTxns, dialogAlert, qDataSaveTransactions, clearSelection, setTxnReviewed]);
    const bulkDelete = react_1.default.useCallback(() => {
        var _a;
        if (selectedTxns.size === 0)
            return;
        const deleteDownloaded = (_a = datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.transactionRegister) === null || _a === void 0 ? void 0 : _a.deleteDownloaded;
        if (!deleteDownloaded && selectedTxns.find((txn) => Boolean(txn.cpData))) {
            dialogAlert('You cannot delete downloaded transactions', 'You selected 1 or more transactions to delete which were downloaded by your financial institution.  It is not recommended that you delete data from your bank as it will not be downloaded again.', undefined, ['Cancel'], 'warning');
            return;
        }
        const numSelected = selectedTxns.size;
        dialogAlert(`Delete ${numSelected} Selected Transaction${numSelected > 1 ? 's' : ''}`, 'This action will delete all the selected transactions and cannot be undone.', (button) => {
            if (button.btnPressed === 'Delete') {
                qDataDeleteTransactions(selectedTxns.toArray(), { isBulkDelete: true });
                clearSelection();
            }
        }, ['Cancel', 'Delete'], 'delete', false);
    }, [selectedTxns, datasetPreferences, dialogAlert, qDataDeleteTransactions, clearSelection]);
    // ── Export logic ──
    const exportRows = react_1.default.useMemo(() => (0, utils_2.buildExportRows)({
        incomeRows,
        expenseRows,
        incomeReport,
        expenseReport,
        isTransactionsView,
        sortBy,
        sortDirection,
        tagsById,
        getTxnAmountForRow,
        getAccountString: (id) => getAccountName(id),
        formatAmount: utils_2.formatAmount,
    }), [
        expenseReport,
        expenseRows,
        getAccountName,
        getTxnAmountForRow,
        incomeReport,
        incomeRows,
        isTransactionsView,
        sortBy,
        sortDirection,
        tagsById,
    ]);
    const selectedExportRows = react_1.default.useMemo(() => (0, utils_2.buildSelectedExportRows)({
        selectedTxns,
        sortBy,
        sortDirection,
        tagsById,
        getAccountString: (accountId) => getAccountName(accountId),
        formatAmount: utils_2.formatAmount,
    }), [selectedTxns, sortBy, sortDirection, tagsById, getAccountName]);
    const datasetName = (dataset === null || dataset === void 0 ? void 0 : dataset.name) || 'Dataset';
    const exportSelectedCsv = react_1.default.useCallback(() => (0, utils_2.exportSelectedToCsv)(selectedExportRows, datasetName), [selectedExportRows, datasetName]);
    const handleDownloadFormat = react_1.default.useCallback((format) => {
        if (format === 'xlsx')
            (0, utils_2.exportToXlsx)(exportRows, datasetName);
        else if (format === 'csv')
            (0, utils_2.exportToCsv)(exportRows, datasetName);
        else if (format === 'pdf')
            (0, utils_2.exportToPdf)(exportRows, datasetName, dateRange.label);
    }, [exportRows, datasetName, dateRange.label]);
    // ── Derived values ──
    const overallTotal = (((_a = incomeReport === null || incomeReport === void 0 ? void 0 : incomeReport.get('rawReport')) === null || _a === void 0 ? void 0 : _a.get('total')) || 0) +
        (((_b = expenseReport === null || expenseReport === void 0 ? void 0 : expenseReport.get('rawReport')) === null || _b === void 0 ? void 0 : _b.get('total')) || 0);
    return (<>
      {showBulkEdit && (<BulkEditPanel_1.default txnArray={selectedTxns} inDialog closeFn={() => setShowBulkEdit(false)} saveFn={bulkEditSave} longCats/>)}

      <Paper_1.default elevation={0} sx={{ backgroundColor: 'background.default' }}>
        <ChartSettings_1.default showDownloadButton handleDownload={handleDownloadFormat} resetTransactionRegister={() => setExpandedKeys({})} showViewFilter viewOptions={types_2.viewOptions} viewValue={view} onViewChange={(option) => {
            const nextView = option.value;
            setView(nextView);
            setExpandedKeys({});
        }} breakdownOptions={types_2.breakdownOptions} breakdownValue={breakdownBy} onBreakdownChange={(option) => {
            setBreakdownBy(option.value);
            setExpandedKeys({});
        }}/>

        {incomeRows.length === 0 && expenseRows.length === 0 ? (<Box_1.default className={classes.tableZeroState} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ZeroStateView_1.default primary=" " icon={happy_star_svg_1.default} iconSize={{ width: 180, height: 180 }} secondary={<>
                  <span>No transactions for {((_c = dateRange === null || dateRange === void 0 ? void 0 : dateRange.label) === null || _c === void 0 ? void 0 : _c.startsWith('Last')) ? 'the ' : ''}{(_d = dateRange === null || dateRange === void 0 ? void 0 : dateRange.label) === null || _d === void 0 ? void 0 : _d.toLowerCase()}</span>
                  <br />
                  <span>Try choosing a different date range</span>
                </>} secondaryTypographyProps={{ sx: { maxWidth: 'none', whiteSpace: 'nowrap' } }}/>
          </Box_1.default>) : (<ItemizedTable_1.default incomeRows={incomeRows} expenseRows={expenseRows} overallTotal={overallTotal} view={view} isTransactionsView={isTransactionsView} maxDepth={maxDepth} sortBy={sortBy} sortDirection={sortDirection} hasUserSorted={hasUserSorted} expandedKeys={expandedKeys} selectedTxns={selectedTxns} visibleTxns={visibleTxns} tagsById={tagsById} checkboxSize={(_f = (_e = theme.components) === null || _e === void 0 ? void 0 : _e.register) === null || _f === void 0 ? void 0 : _f.checkboxSize} palette={palette} classes={classes} cx={cx} getAccountName={getAccountName} getTxnAmountForRow={getTxnAmountForRow} onHeaderSort={handleHeaderSort} onToggleExpanded={toggleExpanded} onToggleTxnSelected={toggleTxnSelected} onToggleSelectAllVisible={toggleSelectAllVisible} onShowBulkEdit={() => setShowBulkEdit(true)} onBulkDelete={bulkDelete} onExportSelectedCsv={exportSelectedCsv} selectedTotal={selectedTotal}/>)}
      </Paper_1.default>
    </>);
};
exports.default = ItemizedTransactions;
